module.exports = __webpack_public_path__ + "static/media/aff.f29b0338.png";